import React from 'react'
import styled from '~/app/components/styled'
import { Renderable } from './index'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * EmphasizedDescription component
 * author: soojin.oh
 */

// type definitions
export type EmphasizedDescriptionProps = {
  title: Renderable
  subTitle?: Renderable
  description: Renderable
}

// styled components
const Container = styled.div`
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 2rem;
  color: ${({ theme }) => theme.color.gray900};
`
const Title = styled.span`
  ${Typography('body1').regular};
`
const SubTitle = styled.span`
  ${Typography('badge').bold};
  background: ${({ theme }) => theme.color.gray100};
  border-radius: 0.4rem;
  padding: 0.2rem 0.6rem;
  margin-left: 0.6rem;
  vertical-align: text-bottom;
`
const Description = styled.div`
  ${Typography('subtitle1').bold};
`

// EmphasizedDescription component
const EmphasizedDescription: React.FunctionComponent<EmphasizedDescriptionProps> = function ({
  title,
  subTitle,
  description,
}) {
  return (
    <Container>
      <div>
        <Title>{title}</Title>
        {subTitle ? <SubTitle>{subTitle}</SubTitle> : null}
      </div>
      <Description>{description}</Description>
    </Container>
  )
}

export default EmphasizedDescription
